import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";
import { DocumentInputContentV1 } from "@demo/types/documentContent";

export const solarInspectionExample: TemplateDefinition = {
  mode: "compose",
  slug: "solar-inspection-example",
  version: 1,
  title: "Infrastructure",
  description: "Inspecting assets",
  thumbnailUuid: BASE_ASSETS.solarInspectionExample.uuid,
  assets: [BASE_ASSETS.solarInspectionExample],
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.solarInspectionExample.uuid,
              extension: BASE_ASSETS.solarInspectionExample.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: {
          type: "text",
          value:
            "Run a quality assessment on the solar panel. Point to any damage and determine a course of action. Be concise.",
        },
      },
    ],
    outputAnnotations: false,
    variables: {},
    annotationFormat: "box",
    enableThinking: true,
  } satisfies DocumentInputContentV1,
};
